import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ViewType } from '../core/models/view-type.model';

export class MaintenanceTypeFormBaseComponent {
  maintenanceTypeForm: FormGroup;
  errorMessage: string | null = null;
  viewTypes: ViewType[] = [];

  constructor(protected fb: FormBuilder) {
    this.maintenanceTypeForm = this.fb.group({
      name: ['', Validators.required],
      viewTypeId: [null, Validators.required],
    });
  }

  markAllFieldsAsTouched() {
    Object.keys(this.maintenanceTypeForm.controls).forEach(field => {
      const control = this.maintenanceTypeForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  get name() {
    return this.maintenanceTypeForm.get('name')!;
  }

  get viewTypeId() {
    return this.maintenanceTypeForm.get('viewTypeId')!;
  }
}
